import PropTypes from 'prop-types';
import React from 'react';
import Classnames from 'classnames';

require('./style.scss');

const Input = (props) => {
  const commonProps = {
    className: Classnames(
      'input', props.className, {
        'full-width': props.fullWidth,
        rounded: props.rounded,
        disabled: props.disabled,
      }),
    defaultValue: props.defaultValue,
    disabled: props.disabled,
    onBlur: props.onBlur,
    placeholder: props.placeholder,
    type: props.type,
    ref: props.inputRef,
  };

  return props.multiline ?
    <textarea {...commonProps} /> :
    <input {...commonProps} />;
};

Input.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  inputRef: PropTypes.func,
  rounded: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

module.exports = Input;



// WEBPACK FOOTER //
// ./app/components/common/input/Input.jsx